
import Vue from 'vue'
import SchoolSearch from './SchoolSearch.vue'

import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'

export default Vue.extend({
   name: 'SchoolSelection',
   data() {
      return {
         success: false,
         showError: false,
         searchAttempts: 0,
      }
   },
   computed: {
      countryCode(): string {
         return this.$store.state.modelData.CountryCode
      },
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
   },
   methods: {
      schoolSelected(school: any) {
         this.success = false
         this.$store.commit('setSchoolLookupResult', school)
         this.$emit('input')
      },
      schoolFinderError(errorMessage: string) {
         this.showError = true
      },
      searchAttempt() {
         this.searchAttempts += 1
         if (this.searchAttempts > 12 && !this.success) {
            this.showError = true
         }
      },
   },
   components: {
      SchoolSearch,
   },
})
